/**
 * A single tab page. It renders the passed template
 * via the @Input properties by using the ngTemplateOutlet
 * and ngTemplateOutletContext directives.
 */

import { Component, ContentChild, Input, TemplateRef } from "@angular/core";

@Component({
    selector: "my-tab",
    templateUrl: "./tab.component.html",
    styleUrls: ["./tab.component.scss"],
    standalone: false
})
export class TabComponent {
	@Input("tabTitle") title: string;
	@Input() active = false;

	/**
	 * Optional rich title template. Project an `<ng-template myTabTitle>`
	 * as a child of `<my-tab>` to render dynamic content (icons, counts,
	 * conditional copy) in the tab header instead of the plain `tabTitle`
	 * string.
	 */
	@ContentChild('myTabTitle', { read: TemplateRef }) titleTemplate?: TemplateRef<unknown>;
}
